var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.5a.75.75 0 01.75.75v5c0 .138.112.25.25.25h5a.75.75 0 010 1.5h-5A1.75 1.75 0 013 19.25v-5a.75.75 0 01.75-.75zM20.25 13.5a.75.75 0 01.75.75v5A1.75 1.75 0 0119.25 21h-5a.75.75 0 010-1.5h5a.25.25 0 00.25-.25v-5a.75.75 0 01.75-.75zM9.75 3a.75.75 0 010 1.5h-5a.25.25 0 00-.25.25v5a.75.75 0 01-1.5 0v-5C3 3.784 3.784 3 4.75 3h5zM19.25 3c.966 0 1.75.784 1.75 1.75v5a.75.75 0 01-1.5 0v-5a.25.25 0 00-.25-.25h-5a.75.75 0 010-1.5h5z",
    fill: "currentColor"
  })));
}
SvgFullscreen.displayName = 'Fullscreen';
export default SvgFullscreen;